import { StrictMode } from 'react';
import React from "react";
import ReactDOM from "react-dom";
import "regenerator-runtime/runtime";
import * as Flex from "@twilio/flex-ui";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import uhaulStore from "./CustomRedux/UhaulStore";
import { updateCurrentUser } from "./Components/Actions/CurrentUserActions";
import { TaskInfoSection } from "./Components/TaskInfoSection";
import { SupervisorTransferChatButton } from "./Components/SupervisorTransferChatButton";
import { HighlightTaskListView } from "./Components/HighlightTaskListView";
import { updateFilterQueues, updateTaskSwitchTimeStamp } from "./Components/Actions/SupervisorStatisticsActions";
import ExceptionLogger from "./ExceptionHelper";
import { TriggerDataRefresh } from "./RefreshStats";
import { AgentStatistics } from "./Components/AgentStatistics";
import { updateTaskContexts } from "./Components/Actions/CannedResponsesActions";
import { updateConfig } from "./Components/Actions/StoreActions";
import { CRM } from "./Components/CRM";
import { FaxButton } from "./Components/FaxButton";
import { ManageSettingsPage, ManageSettingsButton } from "./Components/ManageSettingsPage";
import { IndicateAgentToGM } from "./Components/IndicateAgentToGM"
import { MarkOfflineButton } from "./Components/MarkOfflineButton";
import { MonitoringOnlyToggle } from "./Components/MonitoringOnlyToggle";
import { ColumnDefinition } from "@twilio/flex-ui";
import { Text } from "@twilio/flex-ui/node_modules/@twilio-paste/core/node_modules/@twilio-paste/text";
import { HandleWrappingChat } from "./Components/HandleWrappingChat";
import { SupervisorActionPanel } from "./Components/SupervisorActionPanel";
import { registerBrowserNotification, BROWSER_NOTIFICATION_ID } from "./Components/BrowserNotification";
import { extractFriendlyName, initialResponseBody, sendMessage } from "./Components/Actions/CommonActions"
import { InitialAgentMessage } from "./Components/InitialAgentMessage"
import DownloadTranscriptButton from "./Components/DownloadTranscriptButton";
import { QueuesStatsView } from "@twilio/flex-ui";
import { QueueStatsFilter } from "./Components/QueueStatsFilter";
import { initFeatures } from "./Features";
import { registerOnlineStatusHelper } from "./Components/Actions/OnlineStatusActions";
import { TeamsFilter } from "./Components/TeamsFilter";
import GetLiveChatHeader from "./LiveChatHeaderHelper";
import {maskCCNumber} from "./Services/features/functions/common/maskCreditCardNumber";
import testTwilioTlsConnection from "./TlsTestHelper";
import fetchWorkerProfileInfo from "./WorkerProfileHelper";
import parkingState from "./Features/feature-library/conversation-transfer/helpers/parkingState";

const mountNode = document.getElementById("root");
var workerName = "", userSmid = -1, sid = "", workerAttributes = null, sessionId = "", workerPermissions = null;
var isSupervisor = false; //, hasStatsAdded = false;

window.onload = () => {
  try {
    const predefinedConfig = window.appConfig || {};

    const configuration = {
      ...predefinedConfig,
    };

    Flex
      .progress(mountNode)
      .provideLoginInfo(configuration, mountNode)
      .then(() => Flex.Manager.create(configuration))
      .then(manager => {
        try {
          uhaulStore.dispatch(updateConfig(configuration));

          initFeatures(Flex, manager);
          // #region Strings and Templates
          manager.strings.TaskLineChatAssigned = manager.strings.TaskLineWebChatAssigned = `<div style="display: flex;flex-direction: column;align-items: baseline;"><p class="TaskListItemSecondLine"> {{#if task.attributes.MonitoredBy}} <div class='highlight'>Monitoring - {{task.attributes.type}} {{else}} {{#if task.attributes.isEscalated}} Transferred from {{task.attributes.taskQueue}} {{else}} {{task.queueName}} {{/if}} {{/if}} - {{helper.durationSinceUpdate}} </p> <p class="TaskListItemSecondLine"> {{#if task.selected}} {{#if helper.chat.lastMessage}} {{helper.chat.lastMessage.source.body}} {{else}} No messages {{/if}} {{else}} {{#if task.hasNewUnreadMessages}} {{#if helper.chat.lastMessage}} <b class="BoldedMessage">{{helper.chat.lastMessage.source.body}}</b> {{else}}No messages {{/if}} {{else}} {{#if helper.chat.lastMessage}} {{helper.chat.lastMessage.source.body}} {{else}} No messages {{/if}} {{/if}} {{/if}} </p></div>`;
          manager.strings.TaskExtraInfo = "<h1>LOTS OF STUFF HERE</h1>";
          manager.strings.TaskHeaderLine = "{{task.attributes.friendlyName}}";
          manager.strings.SupervisorTaskHeaderLine = "{{task.attributes.friendlyName}}";
          manager.strings.TaskLineChatReserved = "<div class='BoldedMessage'>{{#if task.attributes.MonitoredBy}} <div class='highlight'>Monitor {{task.attributes.type}}</div> {{else}}{{#if task.attributes.isEscalated}} Transferred from {{task.attributes.taskQueue}}{{else}}{{task.queueName}}{{/if}}{{/if}}</div>";
          manager.strings.SideNavSupervisorDashboard = "Supervisor Dashboard";
          manager.strings.TaskHeaderStatusAccepted = manager.strings.TaskHeaderWebChatStatusAccepted = `{{#if helper.isMyTask}}
                                                                                                            {{#if helper.isCustomerOnline}} {{{icon name='GreenIndicator'}}}<span style="font-weight: bold;">Customer is online &nbsp;</span> 
                                                                                                            {{else}} 
                                                                                                                  {{#if helper.chat.typers.length}} {{{icon name='GreenIndicator'}}}<span style="font-weight: bold;">Customer is online &nbsp;</span> 
                                                                                                                  {{else}} {{{icon name='GreyIndicator'}}}<span style="font-weight: bold;">Customer is <text style="color:red">offline</text> &nbsp;</span> 
                                                                                                                  {{/if}}
                                                                                                            {{/if}}
                                                                                                        {{else}}
                                                                                                            {{{icon name='GreenIndicator'}}}<span style="font-weight: bold;">Customer is online &nbsp;</span>
                                                                                                        {{/if}} | {{helper.durationSinceUpdate}}`;
          //manager.strings.TaskHeaderStatusAccepted = manager.strings.TaskHeaderWebChatStatusAccepted = 'Live | {{helper.durationSinceUpdate}} | {{task.attributes.type}}';
          manager.strings.TaskHeaderStatusWrapup = `{{{icon name='GreyIndicator'}}}<b>{{task.status}}</b> | {{helper.durationSinceUpdate}} <br/> {{task.attributes.type}}`;
          manager.strings.SupervisorTaskCardHeader = `{{task.attributes.friendlyName}}`;
          manager.strings.SupervisorTaskLive = "{{task.attributes.type}} <br/> {{helper.durationSinceUpdate}}";
          manager.strings.SupervisorTaskInfoPanelContent = manager.strings.TaskInfoPanelContent = `<h1>CUSTOMER CONTEXT</h1>`;
          manager.strings.RuntimeLoginErrorSso = "Oops! Well, that didn’t work :( Please check back later or notify your supervisor.";
          manager.strings.RuntimeLoginWithTwilio = "Login Now";
          manager.strings.LoginTitle = "U-Haul Live Chat";
          manager.strings.TaskHeaderComplete = "Complete";
          manager.strings.TaskHeaderEndChat = "End Chat";
          manager.strings.ColumnHeaderTasks = "Chats";
          // #endregion

          // #region Worker Data initialization and Permissions

          if (manager.workerClient && manager.workerClient.attributes) {
            if (manager.workerClient.sid != null) {
              sid = manager.workerClient.sid;
            }

            sessionId = manager.workerClient.attributes.session_id;
            if (sessionId) {
              fetch(`${predefinedConfig.liveChatApiUrl}security?sessionId=${sessionId}`, {
                method: "GET",
                headers: GetLiveChatHeader()
              })
                .then((response) => {
                  if (response.ok) {
                    response.json().then((json) => {
                      workerPermissions = json.map(function (x) {
                        return x.Name;
                      });
                    });
                  } else {
                    return response.text().then((text) => {
                      throw new Error(text);
                    });
                  }
                })
                .catch((err) => {
                  console.log("FETCH ERROR: ", err);
                  ExceptionLogger(err, "index.js", "Error with GetActiveRoles", "", `${sessionId}`);
                });
            }


            workerAttributes = manager.workerClient.attributes;
            if (workerAttributes.full_name != null) {
              workerName = workerAttributes.full_name;
              uhaulStore.dispatch(updateCurrentUser({
                "sid": sid,
                "workerName": workerAttributes.full_name,
                "hrGuid": workerAttributes.hrguid,
                "friendlyName": manager.workerClient.name,
                "serviceBaseUrl": configuration.serviceBaseUrl,
                "featuresBaseUrl": configuration.featuresBaseUrl,
                "queues": workerAttributes.types,
                "attributes": workerAttributes,
                "sessionGuid": sessionId
              }));
            }
            if (workerAttributes.types && workerAttributes.types.length > 0) {
              let foundRoleType = workerAttributes.types.find(e => e === "supervisor-monitor");
              if (foundRoleType != null && foundRoleType !== "") {
                isSupervisor = true;
              }
            }
            if (workerAttributes.roles != null && workerAttributes.roles.length > 0) {
              var foundRoles = workerAttributes.roles;

              //check if the worker is a predefined supervisor
              let foundSupervisorRole = foundRoles.find(e => e === "supervisor");
              if (foundSupervisorRole != null && foundSupervisorRole !== "") {
                isSupervisor = true;
              }
            }
            if (manager.workerClient.name != null) {
              if (/^\d+$/.test(manager.workerClient.name)) {

                //if the smid is present
                userSmid = manager.workerClient.name;
                //var customName = workerName.replace(/\s/g, '_') + "(" + userSmid + ")";
              }
            }
            //if (typeof workerAttributes.session_id !== 'undefined' && workerAttributes.session_id) {
            //  sessionId = workerAttributes.session_id;
            //}
            //if (typeof workerAttributes.hrGuid != 'undefined' && workerAttributes.hrGuid != null && workerAttributes.hrGuid.trim() !== "") {
            //  hrGuid = workerAttributes.hrGuid;
            //}
            //else if (typeof workerAttributes.hrguid != 'undefined' && workerAttributes.hrguid != null && workerAttributes.hrguid.trim() !== "") {
            //  hrGuid = workerAttributes.hrguid;
            //}

          }
          else {
            workerName = manager.workerClient.name;
          }

          workerName = extractFriendlyName(workerName);

          var newTimeStamp = new Date();
          uhaulStore.dispatch(updateTaskSwitchTimeStamp({ "timestamp": newTimeStamp.getTime() }));

          //remove the teams tab and site access
          if (manager.workerClient != null && manager.workerClient.attributes != null &&
            ((manager.workerClient.attributes.types != null && !manager.workerClient.attributes.types.find(x => x.includes("supervisor") || x.includes("admin"))) ||
              (manager.workerClient.attributes.roles != null && !manager.workerClient.attributes.roles.find(x => x.includes("supervisor") || x.includes("admin"))))) {
            Flex.SideNav.Content.remove("teams");
          }
          // #endregion

          // #region Listeners
          Flex.Actions.addListener("beforeSetActivity", (payload) => {
              ExceptionLogger(null, "beforeSetActivity", `Twilio Started to change agent status for ${userSmid} to ${payload.activityName}`, "", payload, true);
          });
          Flex.Actions.addListener("afterSetActivity", (payload) => {
              ExceptionLogger(null, "afterSetActivity", `Twilio Server successfully changed agent status for ${userSmid} to ${payload.activityName}`, "", payload, true);
          });
          Flex.Actions.addListener("afterSetWorkerActivity", (payload) => {
              fetchWorkerProfileInfo(configuration.serviceBaseUrl, payload.workerSid).then(({ smid }) => {
                  ExceptionLogger(null, "afterSetWorkerActivity", `Supervisor ${userSmid} changed agent ${smid ?? payload.workerSid} status to ${payload.activityName}`, "", { ...payload, agentSmid: smid }, true);
              });
          });

          document.addEventListener("click", (event) => {
              const activityToggle = event.target.closest(".Twilio-MainHeader button[aria-haspopup]");
              if (activityToggle) {
                  ExceptionLogger(null, "activityMenuButtonClicked", `Agent ${userSmid} clicked the status dropdown`, "", { workerSid: sid }, true);
              }
          }, true);

          Flex.Actions.addListener("beforeSelectTaskInSupervisor", (payload) => {
            if (payload && payload.task) {
              uhaulStore.dispatch(updateTaskContexts(payload.task));
            }
          });

          //update the agent's name on the task
          Flex.Actions.addListener("afterAcceptTask", (payload) => {
            if (!payload?.task?.attributes) return;

            /* RFP - 7/12/2021
              * Check if task is Mobile-Advantage
              * */
            if (payload.task.attributes.type?.includes("mobile-advantage")) {
              var callUrl = payload.task.attributes.openUrl && payload.task.attributes.openUrl.trim() !== '' 
                ? decodeURIComponent(payload.task.attributes.openUrl) 
                : predefinedConfig.mobileAdvantageUrl + payload.task.attributes.callId;
              window.open(callUrl);
              return;
            }

            setTimeout(function () {
              var sid = payload.task.attributes.channelSid;
              var author = workerAttributes?.public_identity ?? "";
              const body = initialResponseBody(payload.task);
              
              sendMessage(sid, author, body);
            }, 300)

            var actions = [];
            var newTimeStamp = new Date();
            uhaulStore.dispatch(updateTaskSwitchTimeStamp({ "timestamp": newTimeStamp.getTime() }));


            //if a monitoring task
            /*
            if(payload.task.attributes.originalTaskSID != null && payload.task.attributes.isBarging == null)
            {
                Flex.MessageInput.Content.replace(<HandleTextCursorkey key="HandleTextCursorkey" getProps={false} taskSid={payload.task.taskSid} phoneNumber={payload.task.attributes.phoneNumber}/>);
            }
            */

            if (payload.task.attributes.MonitoredBy == null) {
              var newTaskAttributes = payload.task._task.attributes;
              var supervisorUser = uhaulStore.getState().UhaulReducer.currentUser;
              newTaskAttributes["agent"] = workerAttributes?.full_name?.trim() !== "" ? workerAttributes.full_name : workerName;

              actions.push(new Promise(resolve => setTimeout(() => resolve(
                fetch(predefinedConfig.serviceBaseUrl + 'update-task',
                  {
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    method: "POST",
                    body: new URLSearchParams({
                      Token: manager.user.token,
                      NewAttributes: JSON.stringify(newTaskAttributes),
                      TaskSid: payload.task._task.sid,
                      AgentName: newTaskAttributes["agent"],
                      AgentSmid: (userSmid > 0 ? userSmid : (supervisorUser?.friendlyName ?? ""))
                    })
                  }).catch((err) => {
                    console.log("FETCH ERROR: ", err);
                    ExceptionLogger(err, "Index.js", "Error with UpdateTask SetUp Monitoring", "", `${payload.task._task.sid}`);
                  })
              ), 100)));
            }

            /*12/26/18 - C Lam - Fix the smid during chat transfer*/
            if (payload.task.attributes.previousTaskSid != null && payload.task.attributes.members != null) {
              var fn = function reAddMembers(member) {
                if (member?.memberName == null || member?.memberID == null) return null;

                return new Promise(resolve => setTimeout(() => resolve(
                  fetch(predefinedConfig.serviceBaseUrl + "re-add-member",
                    {
                      headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                      },
                      method: "POST",
                      body: new URLSearchParams({
                        Token: manager.user.token,
                        MemberSID: member.memberID,
                        MemberIdentity: member.memberName,
                        ChannelSid: payload.task.attributes.channelSid
                      })
                    }).catch((err) => {
                      console.log("Fetch ERROR: ", err);
                      ExceptionLogger(err, "Index.js", "Error with UpdateTask Add Members", "", `${payload.task.attributes.channelSid}`);
                    })
                ), 100));

              };
              actions.push(Array.from(payload.task.attributes.members).map(fn));
            }

            var results = Promise.all(actions);
            results.then(data =>
              console.log("Reloaded")
            ).catch((err) => {
              console.log("ERROR: ", err);
              ExceptionLogger(err, "Index.js", "Error with Promise", "", "");
            });

            // Attach first response time listener now that the worker is a confirmed participant in the conversation
            const channelSid = payload.task.attributes.channelSid;
            if (channelSid) {
              manager.conversationsClient.getConversationBySid(channelSid)
                .then((channel) => {
                  const publicIdentity = workerAttributes?.public_identity?.toLowerCase().trim();
                  const workerIdentity = manager.user?.identity?.toLowerCase().trim();

                  let autoAcceptSkipped = false;

                  const messageHandler = async (message) => {
                    const authorLower = message.author?.toLowerCase().trim();
                    const isAutoAcceptMessage = authorLower === publicIdentity;
                    const isWorkerTypedMessage = authorLower === workerIdentity;

                    // Skip the auto-accept message (uses public_identity)
                    if (isAutoAcceptMessage && !autoAcceptSkipped) {
                      autoAcceptSkipped = true;
                      return;
                    }

                    // Record first response time when worker sends typed message
                    if (isWorkerTypedMessage) {
                      const attr = payload.task.attributes;

                      // Don't override an already-recorded first response time (e.g. after a transfer)
                      if (attr.conversations?.first_response_time != null) {
                        channel.off('messageAdded', messageHandler);
                        return;
                      }

                      const workerResponseTime = (message.dateCreated.getTime() - channel.dateCreated.getTime()) / 1000;

                      await payload.task.setAttributes({
                        ...attr,
                        conversations: {
                          ...attr.conversations,
                          first_response_time: workerResponseTime
                        }
                      });

                      // Remove the listener
                      channel.off('messageAdded', messageHandler);
                    }
                  };

                  channel.on('messageAdded', messageHandler);
                })
                .catch((err) => {
                  console.log("FETCH ERROR: ", err);
                  ExceptionLogger(err, "Index.js", "Error with first response time listener", "", `${channelSid}`);
                });
            }
          });

          //toggle inputbox
          Flex.Actions.addListener("beforeSelectTask", (payload) => {
            var newTimeStamp = new Date();
            uhaulStore.dispatch(updateTaskSwitchTimeStamp({ "timestamp": newTimeStamp.getTime() }));

            if (payload != null && payload.task != null) {
              uhaulStore.dispatch(updateTaskContexts(payload.task))
              payload.task["selected"] = true;

              //if a monitoring task or task is in "wrapping" state
              if ((payload.task.status != null && payload.task.status === "wrapping") || (payload.task.attributes != null && payload.task.attributes.originalTaskSID != null && payload.task.attributes.isBarging == null)) {
                //Flex.MessageInput.Content.replace(<HandleTextCursorkey key="HandleTextCursorkey" getProps={false} taskSid={payload.task.taskSid} phoneNumber={payload.task.attributes.phoneNumber}/>);
              }
              else if (payload.task.attributes && payload.task.attributes.isBargedOn) {
                //Flex.MessageInput.Content.replace(<HandleTextCursorkey key="HandleTextCursorkey" getProps={false} taskSid={payload.task.taskSid} phoneNumber={payload.task.attributes.phoneNumber}/>);
              }
            }

            //get data for selected chat
            TriggerDataRefresh(uhaulStore.getState().UhaulReducer.currentUser.serviceBaseUrl, uhaulStore.getState().UhaulReducer.config.liveChatApiUrl, uhaulStore.getState().UhaulReducer.currentUser.sessionGuid, [], "Other", true, false);
          });

          //4/19/19 - Task #514004: Live Chat - Logout Does not Set Agents Offline
          Flex.Actions.addListener("beforeLogout", (payload) => {
            Flex.Actions.invokeAction("SetActivity", {
              activityName: "Offline",
              rejectPendingReservations: true
            }).catch((err) => {
              ExceptionLogger(err, "beforeLogout", "Error with SetActivity", "", `${sid != null ? sid : (manager.workerClient.sid != null ? manager.workerClient.sid : null)}`);
            }).then(() => {
              window.location.replace(predefinedConfig.uhaulUrl);
            });
          });

          //
          Flex.Actions.addListener("beforeCompleteTask", (payload, abortFunction) => {
            try {
              if (!payload?.task?.attributes) return;

              const taskSid = payload.task.source.sid;
              let attributes = payload.task.attributes;
              let needsUpdate = false;
              
              if (payload.reason == null || (!payload.reason.includes("Transfer") && !payload.reason.includes('completing wrapped up task') && !payload.reason.includes('Completed manually from button'))) {
                if (!window.confirm("Are you sure you want to end the chat?")) {
                  abortFunction();
                  return;
                }
              }
              
              if (attributes.startingTransferTaskSid) {
                attributes.conversations.conversation_id = attributes.startingTransferTaskSid;
                needsUpdate = true;
              }

              if ('summary' in attributes) {
                delete attributes.summary;
                needsUpdate = true;
              }

              if (needsUpdate) {
                let currentUser = uhaulStore.getState().UhaulReducer.currentUser;
                fetch(predefinedConfig.serviceBaseUrl + 'update-task',
                  {
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    method: "POST",
                    body: new URLSearchParams({
                      Token: manager.user.token,
                      NewAttributes: JSON.stringify(attributes),
                      TaskSid: taskSid,
                      AgentName: ( workerAttributes?.full_name?.trim() !== "" ? workerAttributes.full_name : workerName),
                      AgentSmid: (userSmid > 0 ? userSmid : (currentUser?.friendlyName ?? ""))
                    })
                  })
                  .then(response => {
                    if (!response || !response.ok) {
                      ExceptionLogger(null, "Index.js", "ClosingChatFetch Fail Response", "", response, true)
                      throw new Error("Error with update-task");
                    }
                  })
                  .catch((err) => {
                    console.log("FETCH ERROR: ", err);
                    ExceptionLogger(err, "Index.js", "Error with UpdateTask ClosingChat", "", `${payload.task._task.sid}`);
                  })
              }
            }
            catch (error) {
              console.error(error);
            }
          });

          manager.conversationsClient.addListener("participantLeft", async (payload) => {
            try {
              //Particpant that left was this user
              if (payload.identity == manager.user.identity && ((workerAttributes.types != null && workerAttributes.types.length > 0 && workerAttributes.types.includes("supervisor")) ||
                (workerAttributes.roles != null && workerAttributes.roles.length > 0 && workerAttributes.roles.includes("supervisor")))) {
                const conversationSid = payload.conversation.sid;
                const token = manager.user.token;
                if (conversationSid != null && token != null) {
                  const parkingFinished = await parkingState.waitForParkingToFinish(conversationSid);
                  if (!parkingFinished) {
                    ExceptionLogger(
                      new Error("Parking did not finish before the supervisor count update retry limit."),
                      "Index.js",
                      "Updating supervisor count after parking retry limit",
                      "",
                      { conversationSid }
                    );
                  }

                  const response = await fetch(predefinedConfig.serviceBaseUrl + "update-supervisor-count", {
                    headers: {
                      "Content-Type": "application/x-www-form-urlencoded"
                    },
                    method: "POST",
                    body: new URLSearchParams({
                      Token: token,
                      conversationSid: conversationSid,
                    })
                  });

                  if (!response.ok) {
                    throw new Error(`Failed to update supervisor count.`);
                  }
                }
              }
            } catch (error) {
              console.error(error);
              ExceptionLogger(error, "Index.js", "Error with UpdateSupervisorCount", "", `${payload.conversation?.sid ?? ""}`);
            }

          });

          Flex.Actions.addListener("beforeChatTransferTask", (payload) => {
            try {
              let sid = payload.task.attributes.channelSid || payload.task.attributes.conversationSid;
              let author = workerAttributes.public_identity;
              let body = 'You are now being transferred'
              sendMessage(sid, author, body);
            } catch (err) {
              ExceptionLogger(err, "beforeChatTransferTask", "Index.js", "", "");
            }
          });

          Flex.Actions.addListener("beforeParkChat", (payload) => {
            try {
              let sid = payload.task.attributes.channelSid || payload.task.attributes.conversationSid;
              let author = workerAttributes.public_identity;
              let body = 'Please continue chatting to receive help and support.'
              sendMessage(sid, author, body);
            } catch (err) {
              ExceptionLogger(err, "beforeParkChat", "Index.js", "", "");
            }
          });

          Flex.Actions.addListener("beforeSendMessage", (payload) => {
            payload.body = maskCCNumber(payload.body);
          });
          // #endregion

          // #region Custom Content
          Flex.ViewCollection.Content.add(
            <Flex.View name="teams-filter" key="teams-filter" route={{ path: "/teams/filter" }}>
              <div>Loading...</div>
            </Flex.View>
          );
          Flex.CRMContainer.Content.replace(<CRM key="customerHelpTools" />);
          Flex.TaskInfoPanel.Content.add(<TaskInfoSection key="taskInfoSectionPanel" />);
          Flex.Supervisor.TaskInfoPanel.Content.add(<TaskInfoSection key="taskInfoSectionPanel" />);
          Flex.TaskCanvas.Content.add(<IndicateAgentToGM key="IndicateAgentToGMID" />, { sortOrder: 0 });
          Flex.Supervisor.TaskCanvas.Content.add(<IndicateAgentToGM key="IndicateAgentToGMID" />, { sortOrder: 0 });
          Flex.TeamsView.Content.add(<MarkOfflineButton key="Markoffline" flex={Flex} />, { sortOrder: -1, align: "start" })
          Flex.TeamsView.Content.add(<TeamsFilter key="TeamsFilter" flex={Flex} />, { sortOrder: 0 })
          Flex.TeamsView.defaultProps.hiddenFilter = 'data.activity_name != "Offline"';
          Flex.SideNav.Content.add(<FaxButton key="faxButtonKey" />);
          Flex.TaskListItem.Content.add(<HandleWrappingChat key="HandleWrappingChatPanel" />);
          Flex.TaskListItem.Content.add(<HighlightTaskListView key="highlightTaskListKey" />, { if: task => task.selected == null || task.selected === false });
          Flex.TaskListContainer.Content.add(<AgentStatistics key="AgentStats"></AgentStatistics>);
          Flex.Supervisor.TaskCanvasHeader.Content.add(<SupervisorActionPanel key="SupervisorActionPanel" />);
          Flex.MessageInput.Content.add(<InitialAgentMessage key="SendMsgkey" />);
          Flex.MessageInputV2.Content.add(<DownloadTranscriptButton key="DownloadTranscriptButton" />);
          Flex.MainHeader.defaultProps = {
            logoUrl: "https://limerick-marten-3162.twil.io/assets/uhaul-chat-logo.png"
          };
          Flex.MainContainer.defaultProps.showNotificationBar = true;

          Flex.WorkerDirectory.Content.add(<SupervisorTransferChatButton key="supervisorTransferPanel" />, { sortOrder: 0 });
          if (workerAttributes.show_hidden_queues_in_transfer_list == null || workerAttributes.show_hidden_queues_in_transfer_list != 'true') {
            Flex.WorkerDirectoryTabs.defaultProps.queueFilter = (queue) => !predefinedConfig.features.conversationTransfer.queueFilter.includes(queue.queueName)
          }
          Flex.WorkerDirectoryTabs.Content.remove("workers");

          Flex.WorkersDataTable.Content.add(
            <ColumnDefinition
              key="enableMonitoringColumn"
              header={<Text>Monitoring Only</Text>}
              content={(items, context) => <MonitoringOnlyToggle key="monitoring" data-items={items} />}
            />,
            { sortOrder: -1 }
          );

          if (isSupervisor) {
            Flex.SideNav.Content.add(<ManageSettingsButton key="manageSettings" />);
            Flex.ViewCollection.Content.add(<Flex.View name="manage-settings-page" key="customFlexView"><ManageSettingsPage key="ManageSettingsPage" /></Flex.View>);
          }
          // #endregion

          // #region Incoming Task Notification
          Flex.DefaultTaskChannels.Chat.notifications.override.IncomingTask = () => {
            return;
          }
          manager.workerClient.on("reservationCreated", reservation => {
            let formattedQueueName = null
            if (reservation.task && reservation.task.queueName) {
              formattedQueueName = reservation.task.queueName.toLowerCase();
            }
            const allQueues = uhaulStore.getState().UhaulReducer.allQueues;
            const queueMatch = formattedQueueName ? allQueues.find(queueItem => queueItem.Name.toLowerCase().trim() === formattedQueueName.toLowerCase().trim()) : null;
            if (reservation.task.sid) {
              ExceptionLogger(null, "reservationCreated", "queueMatch Log", "", { allQueuesCount: allQueues.length, queueMatch: queueMatch, task: reservation.task.sid }, true);
            }
            fetch(predefinedConfig.serviceBaseUrl + 'auto-accept',
              {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                method: "POST",
                body: new URLSearchParams({
                  Token: manager.user.token,
                  queueName: queueMatch && queueMatch.Type ? queueMatch.Type : ''
                })
              })
              .then((response) => {
                if (response && response.ok) {
                  return response.json();
                }
                else {
                  ExceptionLogger(null, "reservationCreated API Response", "AutoAccept Failed", "", data, true);
                  throw new Error(`Cannot pull from ${predefinedConfig.serviceBaseUrl + 'auto-accept'}`);
                }
              })
              .then((data) => {
                ExceptionLogger(null, "reservationCreated API Response", "Auto-Accept Function Response", "", data, true);
                if (data.IsAutoAccept) {
                  Flex.Actions.invokeAction('AcceptTask', { sid: reservation.sid });
                }
              })
              .catch((err) => {
                console.log("FETCH ERROR: ", err);
                const taskSid = reservation?.task?.sid ?? "";
                ExceptionLogger(err, "Index.js", "Error with AutoAccept", "", `${taskSid}`);

              });

            const uniqueReservationId = reservation.sid + Math.random().toString(16).slice(2);
            const notificationParam = {
              flex: Flex,
              content: "",
              reservationId: uniqueReservationId,
              requireInteraction: true
            }
            if (reservation.task.taskChannelUniqueName === 'mobile-advantage') {
              notificationParam.content = "New Incoming Breakdown";
              registerBrowserNotification(notificationParam);
            }
            else if (reservation.task.taskChannelUniqueName === 'mobile-advantage-accident') {
              notificationParam.content = "New Incoming Accident";
              registerBrowserNotification(notificationParam);
            }
            else {
              notificationParam.content = "New Incoming Chat";
              registerBrowserNotification(notificationParam);
            }
            Flex.Notifications.showNotification(BROWSER_NOTIFICATION_ID, undefined);
          });
          // #endregion

          //Fetch All Queues
          const postServiceUrl = uhaulStore.getState().UhaulReducer.config.liveChatApiUrl;
          const requestUri = postServiceUrl + "Queues";
          fetch(requestUri,
            {
              method: "GET",
              headers: GetLiveChatHeader()
            })
            .then(response => response.json())
            .then(json => {
              if (!json.Success || !json.Data) {
                var errorMessage = json.Errors ? json.Errors.join("\n") : "Unknown error.";
                console.log(errorMessage);
                return;
              }
              uhaulStore.dispatch(updateFilterQueues(json.Data));
            }).catch(err => console.error(err));

          QueuesStatsView.Content.add(<QueueStatsFilter key="queueStatsFilter" />, { sortOrder: 0 })

          renderApp(manager);
          testTwilioTlsConnection(userSmid);
        }
        catch (ec) {
          handleError(ec);
        }
      })
      .catch(error => handleError(error));
  }
  catch (er) {
    handleError(er);
  }
};

registerOnlineStatusHelper();

// Render
function renderApp(manager) {
  ReactDOM.render(
    <StrictMode>
      <App manager={manager} />
    </StrictMode>,
    mountNode
  );
}

// Error Handling
function handleError(error) {
  Flex.errorPage(error, mountNode);
  console.error("Failed to initialize Flex", error);
}

try {
  registerServiceWorker();
}
catch (ecc) {
  ExceptionLogger(ecc, "Registration Areas", "Error with Registering Notification or Service Worker", null, "");
}
